module.exports = __webpack_public_path__ + "static/media/bgr-404.2e1bc387.webp";